import ServiceBase from './serviceBase';
import { CalculatorTransportDto, TransportContextType } from './types/CalculatorTransportRoads';

class CalculatorTransportPavmentsService extends ServiceBase {
  getCalculatorTransportPavmentsSectorContext = async (
    calculatorId: string
  ): Promise<TransportContextType> =>
    this.get<TransportContextType>(`calculatorTransport/${calculatorId}/transport-sector-context`);

  saveCalculatorTransport = async (payload: CalculatorTransportDto): Promise<void> =>
    this.post<void>(`calculatorTransport/saveTransport`, payload);

  finishCalculatorTransport = async (payload: CalculatorTransportDto): Promise<void> =>
    this.post<void>(`calculatorTransport/finishTransport`, payload);
}

const calculatorTransportPavmentsService = new CalculatorTransportPavmentsService();

export default calculatorTransportPavmentsService;
